import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Button,
  FormHelperText,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import UploadImage from "../../UploadImage";
import { modal } from "../../../../util";

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  leftGrid: {
    maxHeight: 100,
  },
  last: {
    margin: 0,
  },
  topBar: {
    padding: 0,
  },
  pagination: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  "&::placeholder": {
    color: "grey",
  },
  helperText: {
    top: "-10px",
    position: "relative",
    left: "5px",
  }
}));

export default function ProductCategoryForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();
  const [originalData, setOriginalData] = React.useState("");

  const { control, handleSubmit, setValue, getValues } = useForm();

  const formatRowToData = (row) => {
    return {
      type: row.type,
      nameEn: row.nameEn,
      nameTc: row.nameTc,
      image: row.image,
      updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss[Z]"),
    }
  }

  useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getProductCategoryById(id)
        .then((response) => {
          console.log(response.data);
          setOriginalData(response.data);
          setValue("type", response.data.type);
          setValue("nameEn", response.data.nameEn);
          setValue("nameTc", response.data.nameTc);
          setValue("image", response.data.image);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateProductCategory = async (data) => {
    try {
      console.log(formatRowToData(data));
      const result = await apiHelper.hkiff.updateProductCategoryById(
        id, formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
    } catch (err) {
      console.log(err);
    }
  };

  const createProductCategory = async (data) => {
    try {
      const result = await apiHelper.hkiff.postProductCategory(
        formatRowToData(data)
      );
      if (result.data.id) {
        toast.dark("Category created.");
        history.push("/hkiff/eshop/product-category");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    console.log(data);
    const sendProductCategory = () => {
      if (id) {
        updateProductCategory(data);
      } else {
        createProductCategory(data);
      }
    };
    sendProductCategory();
  };

  const deleteProductCategory = React.useCallback(async (id) => {
    const decision = await modal.fire({
      title: "Delete Category",
      text: "Are you sure to delete this category?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        const result = await apiHelper.hkiff.deleteProductCategoryById(id);
        if (result.data.code === 0) {
          history.push(`/hkiff/eshop/product-category`);
          toast.dark("Category deleted.");
        }
      } catch (err) {
        console.log(err);
      }
    }
  }, []);

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="type"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Type"
                    variant="outlined"
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <Controller
              control={control}
              name="nameEn"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

<Controller
              control={control}
              name="nameTc"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />


            <UploadImage
              name="image"
              data={originalData}
              control={control}
              Controller={Controller}
              setValue={setValue}
              getValues={getValues}
              disabled={disabled}
              uploadLabel="Category Image"
              changeLabel="Change image"
              uploadFolder="PRODUCT"
            />
            <FormHelperText className={classes.helperText}>
              The image dispaly as category thumbnail.
            </FormHelperText>

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                  {(id != "new" && id) && (
                  <Button
                    variant="text"
                    disableElevation
                    style={{
                      color: "#962013",
                      padding: "9px 16px",
                    }}
                    onClick={() => {
                      deleteProductCategory(id);
                    }}
                  >
                    Delete Category
                  </Button>
                )}
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
